<template>
    <div class="h-screen w-screen fixed top-0" style="z-index: 50;">
        <div @click="closePopup" class="w-full h-full fixed top-0 left-0 bg-grey-800 opacity-50"></div>

        <div class="fixed bottom-0 w-full md:w-3/4 lg:w-1/2 lg:rounded-tl-lg lg:rounded-tr-lg h-auto max-h-full bg-green-90 overflow-y-auto" style="left: 50%; transform: translate(-50%, 0);">
            <div class="flex flex-col max-h-screen overflow-hidden">
				<div class="flex -mb-3 pt-5 pb-3 px-5">
					<h1 class="flex-grow font-sans text-4xl sm:text-5xl m-0 -mt-2 text-green-1000">Set new password</h1>

					<a @click="closePopup" @keypress.enter="closePopup" tabindex="0" class="block relative -mt-2 px-5 cursor-pointer">
						<svg xmlns="http://www.w3.org/2000/svg" class="block absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40px; height: 40px;" viewBox="0 0 31 31" fill="none">
							<path d="M23.25 7.75L7.75 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M7.75 7.75L23.25 23.25" stroke="#2F493C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</a>
				</div>

                <div v-if="this.error" class="mt-2 mb-4 pt-5 pb-4 px-5 bg-red-600 text-white text-xl font-body">
					{{ this.error }}
				</div>

				<div v-if="success" class="pb-5 px-5">
					<p class="text-green-900 text-xl font-body leading-tight mt-2">Succesfully changed your password!</p>
				</div>
				<div v-else class="overflow-y-auto">
					<div class="px-5 pb-5">
						<p class="text-green-900 text-xl font-body leading-tight mt-2 mb-2">Choose a new password below</p>

						<input @keypress.enter="submit" class="mb-2 block w-full font-sans rounded-none bg-transparent text-green-800 placeholder-green-600 border-8 border-solid border-grey-500 px-2 py-2 text-2xl" type="password" placeholder="Choose a new password..." v-model="password" />
						<input @keypress.enter="submit" class="block w-full font-sans rounded-none bg-transparent text-green-800 placeholder-green-600 border-8 border-solid border-grey-500 px-2 py-2 text-2xl" type="password" placeholder="Repeat new password..." v-model="repeat_password" />
					</div>

					<a @click="submit" @keypress.enter="submit" tabindex="0" class="block w-full font-sans border-none bg-grey-700 text-green-300 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
						UPDATE
					</a>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
	props: ["recovery_key"],
	data() {
        return {
			error: "",
			password: "",
			repeat_password: "",
			success: false
        }
	},
	created() {
		if (this.recovery_key == "invalid") {
			this.error = "Invalid recovery link";
		}
	},
    methods: {
		closePopup() {
			this.success = false;
			this.$parent.show_password_reset = false;
		},
        async submit() {
            var that = this;
			this.error = "";

			var re = /^[A-Za-z0-9\-_\.\!\?]{8,64}$/;
			if (!re.test(this.password)) {
				this.error = "Your password can only contain letters, numbers and some symbols(._-!?), and must be between 8 and 64 characters long";
				return;
			}

			if (this.password != this.repeat_password) {
				this.error = "Your two passwords do not match";
				return;
			}

			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/recover/complete?key=' + this.recovery_key + '&password=' + this.password)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.password = "";
					that.repeat_password = "";
					that.success = true;
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An error has occured: " + error;
				}
			});
        }
    }
}
</script>